import { useState } from "react";

// Sidebar assets
import SidebarLogo from "../assets/svg/sidebar-logo.svg";
import SidebarLogoSm from "../assets/svg/sidebar-logo-sm.svg";
import SidebarNav1 from "../assets/svg/sidebar-nav-1.svg";
import SidebarNav2 from "../assets/svg/sidebar-nav-2.svg";
import SidebarNav3 from "../assets/svg/sidebar-nav-3.svg";
import SidebarNav4 from "../assets/svg/sidebar-nav-4.svg";
import SidebarNav5 from "../assets/svg/sidebar-nav-5.svg";
import SidebarNav6 from "../assets/svg/sidebar-nav-6.svg";
import SidebarNav7 from "../assets/svg/sidebar-nav-7.svg";
import SidebarNav8 from "../assets/svg/sidebar-nav-8.svg";
import SidebarNav9 from "../assets/svg/sidebar-nav-9.svg";
import SidebarNav10 from "../assets/svg/sidebar-nav-10.svg";
import SidebarSettings from "../assets/svg/sidebar-settings.svg";
import ChevronRightIcon from "../assets/svg/chevron-right.svg";
// Header
import HeaderBell from "../assets/svg/header-bell.svg";
import HeaderAvatar from "../assets/svg/header-avatar.svg";
import HeaderChevronDown from "../assets/svg/header-chevron-down.svg";
// Tabs
import TabFiling from "../assets/svg/tab-filing.svg";
import TabStatus from "../assets/svg/tab-status.svg";
// Legal Advice
import LegalAdviceHeadset from "../assets/svg/legal-advice-headset.svg";
import InvoiceToClientFinalView from "../views/dashboard/InvoiceToClientFinalView";
import FormalitiesCheckView from "../views/dashboard/FormalitiesCheckView";
import PaymentFromClientView from "../views/dashboard/PaymentFromClientView";
import ChecklistDocumentsToClientView from "../views/dashboard/ChecklistDocumentsToClientView";
import DocumentsFromClientView from "../views/dashboard/DocumentsFromClientView";
import FilingDetailsToClientView from "../views/dashboard/FilingDetailsToClientView";
import ConfirmationOfFilingDetailsView from "../views/dashboard/ConfirmationOfFilingDetailsView";
import StampPaperDetailsToVendorView from "../views/dashboard/StampPaperDetailsToVendorView";
import StampPaperFromVendorView from "../views/dashboard/StampPaperFromVendorView";
import PreparationOfPowerOfAttorneyView from "../views/dashboard/PreparationOfPowerOfAttorneyView";
import PreparationOfUserAffidavitView from "../views/dashboard/PreparationOfUserAffidavitView";
import InactiveStepView from "../views/dashboard/InactiveStepView";
import SignatureFromClientView from "../views/dashboard/SignatureFromClientView";
import NotarisationOfDocumentsView from "../views/dashboard/NotarisationOfDocumentsView";
import ScanningOfDocumentsView from "../views/dashboard/ScanningOfDocumentsView";
import UploadingApplicationDetailsView from "../views/dashboard/UploadingApplicationDetailsView";
import FilingOfApplicationView from "../views/dashboard/FilingOfApplicationView";
import AcknowledgementToClientView from "../views/dashboard/AcknowledgementToClientView";
import FilingOfExpeditedApplicationView from "../views/dashboard/FilingOfExpeditedApplicationView";
import InvoiceToClientForExpeditedApplicationView from "../views/dashboard/InvoiceToClientForExpeditedApplicationView";
import PaymentFromClientExpeditedView from "../views/dashboard/PaymentFromClientExpeditedView";

const MARK_ITEMS = [
  { id: "1", label: "Preliminary Discussion with the Client" },
  { id: "2", label: "Check list for Search to Client" },
  { id: "3", label: "Details for Search from Client" },
  { id: "4", label: "Invoice of Advance Amount to Client" },
  { id: "5", label: "Advance Amount from Client" },
  { id: "6", label: "Class list to Client" },
  { id: "7", label: "Search Report to Client" },
  { id: "8", label: "Legal Advice" },
  { id: "9", label: "Proposal to Client" },
  { id: "10", label: "Confirmation from Client" },
  { id: "11", label: "Invoice to Client (Final)" },
  { id: "12", label: "Payment from Client" },
];

const STATUS_ITEMS = [
  { id: "s1", label: "Formalities Check" },
  { id: "s2", label: "Marked for Exam" },
  { id: "s3", label: "Examination Report" },
  { id: "s5", label: "Advertised in Journal" },
  { id: "s6", label: "Final Order" },
];

const FILING_ITEMS = [
  { id: "f1", label: "Check list of Documents to Client" },
  { id: "f2", label: "Documents from Client" },
  { id: "f3", label: "Filing Details to Client" },
  { id: "f4", label: "Confirmation of Filing Details" },
  { id: "f5", label: "Stamp Paper details to Vendor" },
  { id: "f6", label: "Stamp Paper from Vendor" },
  { id: "f7", label: "Preparation of Power of Attorney" },
  { id: "f8", label: "Preparation of User Affidavit" },
  { id: "f9", label: "Signature from Client" },
  { id: "f10", label: "Notarisation of Documents" },
  { id: "f11", label: "Scanning of Documents" },
  { id: "f12", label: "Uploading Application Details" },
  { id: "f13", label: "Filing of Application" },
  { id: "f14", label: "Acknowledgement to Client" },
  { id: "f15", label: "Filing of Expedited Application" },
  { id: "f16", label: "Invoice to Client for Expedited Application" },
  { id: "f17", label: "Payment from Client (Expedited)" },
];

const NAV_ITEMS = [
  { icon: SidebarNav1, label: "Dashboard" },
  { icon: SidebarNav2, label: "New Application" },
  { icon: SidebarNav3, label: "Follow Ups" },
  { icon: SidebarNav4, label: "Assignments" },
  { icon: SidebarNav5, label: "Opposition" },
  { icon: SidebarNav6, label: "Renewal" },
  { icon: SidebarNav7, label: "Legal Certificate" },
  { icon: SidebarNav8, label: "Surveillance" },
  { icon: SidebarNav9, label: "Reports" },
  { icon: SidebarNav10, label: "Users" },
];

function SideNavigation({
  activeNavIndex,
  onNavSelect,
}: {
  activeNavIndex: number;
  onNavSelect: (idx: number) => void;
}) {
  return (
    <aside
      className="w-[68px] flex-shrink-0 bg-white border-r border-[#EEEEEE] flex flex-col items-center"
      style={{ fontFamily: "Inter, sans-serif" }}
    >
      <div className="px-[14px] pt-4 flex flex-col gap-3">
        <div className="w-[44px] h-[41px] flex items-center justify-center rounded-lg p-2.5 py-3">
          <img src={SidebarLogo} alt="" className="w-[44px] h-[41px]" />
        </div>
        <div className="w-[40px] h-[40px] flex items-center justify-center rounded-lg border border-[#E3EAEF]">
          <img src={SidebarLogoSm} alt="" className="w-[40px] h-[40px]" />
        </div>
      </div>
      <div className="flex-1 px-[14px] pt-4 flex flex-col gap-0.5">
        {NAV_ITEMS.map((item, idx) => (
          <div key={idx} className="group relative flex justify-center">
            <button
              type="button"
              onClick={() => onNavSelect(idx)}
              aria-label={item.label}
              className={`w-[40px] h-9 flex items-center justify-center rounded-lg border-0 cursor-pointer ${
                activeNavIndex === idx
                  ? "bg-[#222222]"
                  : "bg-transparent hover:bg-[#F7F7F7]"
              }`}
              style={
                activeNavIndex === idx
                  ? {
                      boxShadow: "4px 0 0 0 #0070F0",
                      borderRadius: "8px",
                    }
                  : {}
              }
            >
              <img
                src={item.icon}
                alt=""
                className="w-5 h-5"
                style={{
                  filter:
                    activeNavIndex === idx ? "brightness(0) invert(1)" : "none",
                }}
              />
            </button>
            <span
              role="tooltip"
              className="pointer-events-none absolute left-full top-1/2 z-50 ml-2 -translate-y-1/2 whitespace-nowrap rounded-md bg-[#222222] px-2 py-1 text-xs font-medium text-white opacity-0 shadow-lg transition-opacity duration-150 group-hover:opacity-100 group-focus-within:opacity-100"
            >
              {item.label}
            </span>
          </div>
        ))}
        <div className="group relative mt-2 flex justify-center">
          <button
            type="button"
            aria-label="Settings"
            className="w-[40px] h-9 flex items-center justify-center rounded-lg hover:bg-[#F7F7F7] border-0 cursor-pointer"
          >
            <img src={SidebarSettings} alt="" className="w-5 h-5" />
          </button>
          <span
            role="tooltip"
            className="pointer-events-none absolute left-full top-1/2 z-50 ml-2 -translate-y-1/2 whitespace-nowrap rounded-md bg-[#222222] px-2 py-1 text-xs font-medium text-white opacity-0 shadow-lg transition-opacity duration-150 group-hover:opacity-100 group-focus-within:opacity-100"
          >
            Settings
          </span>
        </div>
      </div>
    </aside>
  );
}

function HeaderBar() {
  return (
    <header
      className="h-14 flex-shrink-0 bg-white border-b border-[#EEEEEE] flex items-center justify-between py-2 gap-[89px] px-4"
      style={{ fontFamily: "Inter, sans-serif" }}
    >
      <div
        className="text-sm font-normal text-[#222222]"
        style={{ letterSpacing: "0.14px" }}
      >
        UPRIGHT LEGAL New Application
      </div>
      <div className="flex items-center gap-2">
        <button
          className="w-7 h-7 min-w-[28px] min-h-[28px] flex items-center justify-center rounded-xl hover:bg-[#F7F7F7]"
          aria-label="Notifications"
        >
          <img src={HeaderBell} alt="" className="w-7 h-7" />
        </button>
        <div className="flex items-center gap-2 p-2 rounded-lg hover:bg-[#F7F7F7] cursor-pointer">
          <img src={HeaderAvatar} alt="" className="w-6 h-6 rounded-full" />
          <span className="text-sm font-normal text-[#222222]">ByeWind</span>
          <img src={HeaderChevronDown} alt="" className="w-5 h-5" />
        </div>
      </div>
    </header>
  );
}

function TabBar({
  activeTab,
  onTabChange,
}: {
  activeTab: "discussion" | "filing" | "status";
  onTabChange: (t: "discussion" | "filing" | "status") => void;
}) {
  return (
    <div
      className="h-[46px] flex-shrink-0 border-b border-[#EEEEEE] flex items-center pl-[10px] pt-1.5"
      style={{ fontFamily: "Inter, sans-serif" }}
    >
      <button
        onClick={() => onTabChange("discussion")}
        className={`px-2.5 py-2.5 text-sm border-b -mb-px transition-colors ${
          activeTab === "discussion"
            ? "font-semibold text-[#222222] border-b-2 border-[#222222]"
            : "font-normal text-[#222222] border-transparent"
        }`}
        style={{ lineHeight: "20px" }}
      >
        Discussion
      </button>
      <button
        onClick={() => onTabChange("filing")}
        className={`px-2.5 py-2.5 text-sm border-b -mb-px flex items-center gap-2 transition-colors ${
          activeTab === "filing"
            ? "font-semibold text-[#222222] border-b-2 border-[#222222]"
            : "font-normal text-[#222222] border-transparent"
        }`}
        style={{ lineHeight: "20px" }}
      >
        <img src={TabFiling} alt="" className="h-5 w-auto object-contain" />
        Filing
      </button>
      <button
        onClick={() => onTabChange("status")}
        className={`px-2.5 py-2.5 text-sm border-b -mb-px flex items-center gap-2 transition-colors ${
          activeTab === "status"
            ? "font-semibold text-[#222222] border-b-2 border-[#222222]"
            : "font-normal text-[#222222] border-transparent"
        }`}
        style={{ lineHeight: "20px" }}
      >
        <img src={TabStatus} alt="" className="h-5 w-auto object-contain" />
        Status
      </button>
    </div>
  );
}

function LeftPanel({
  items,
  activeMarkId,
  onMarkSelect,
}: {
  items: { id: string; label: string }[];
  activeMarkId: string;
  onMarkSelect: (id: string) => void;
}) {
  return (
    <div
      className="w-[279px] flex-shrink-0 border-r border-[#EEEEEE] p-2.5 overflow-y-auto"
      style={{ fontFamily: "Inter, sans-serif" }}
    >
      <div className="flex flex-col gap-2">
        {items.map((item) => {
          const isSelected = activeMarkId === item.id;
          return (
            <button
              key={item.id}
              onClick={() => onMarkSelect(item.id)}
              className={`w-full max-w-[259px] h-10 flex items-center justify-between px-2.5 rounded-md text-left transition-colors ${
                isSelected
                  ? "bg-[#222222] text-white"
                  : "bg-[#F7F7F7] text-[#222222] hover:bg-[#EEEEEE]"
              }`}
              style={{
                fontSize: "12px",
                lineHeight: "20px",
                fontFamily: "Inter, sans-serif",
              }}
            >
              <span className="truncate">{item.label}</span>
              <img
                src={ChevronRightIcon}
                alt=""
                className="w-4 h-4 flex-shrink-0 ml-1"
                style={{
                  filter: isSelected ? "brightness(0) invert(1)" : "none",
                }}
              />
            </button>
          );
        })}
      </div>
    </div>
  );
}

function LegalAdviceView() {
  const [mark, setMark] = useState("");

  return (
    <div
      className="flex flex-col gap-5 max-w-[1085px]"
      style={{ fontFamily: "Inter, sans-serif" }}
    >
      {/* Step 8: Legal Advice alert box - Figma: #FFECD3 bg, #E18308 dashed */}
      <div
        className="flex flex-row flex-wrap items-center justify-between gap-5 p-5 rounded-2xl border border-dashed border-[#E18308] bg-[#FFECD3]"
        style={{ gap: "20px" }}
      >
        <div className="w-[72px] h-[72px] flex-shrink-0 flex items-center justify-center">
          <img
            src={LegalAdviceHeadset}
            alt=""
            className="w-[72px] h-[72px] object-contain"
          />
        </div>
        <div className="flex-1 min-w-[200px] flex flex-col gap-2">
          <h3
            className="text-sm font-semibold text-[#222222]"
            style={{ lineHeight: "20px", letterSpacing: "0.14px" }}
          >
            Step 8: Legal Advice (Phone Conversation)
          </h3>
          <ul
            className="text-sm font-normal text-[#222222] list-disc list-inside space-y-1 pl-0"
            style={{ lineHeight: "20px" }}
          >
            <li>
              Nothing to be done here. It is a phone conversation with the
              client.
            </li>
            <li>
              If the client gets convinced that the mark they have given is not
              available for registration, they might share another mark for
              search.
            </li>
          </ul>
        </div>
        <button
          type="button"
          className="flex-shrink-0 h-9 px-4 text-xs font-semibold text-white rounded-md bg-[#222222] hover:bg-[#333333] transition-colors"
          style={{ lineHeight: "20px" }}
        >
          Call Now
        </button>
      </div>

      {/* Mark section - Figma: gap 16px, font 500 14px, input border-radius 6px */}
      <div className="flex flex-col gap-4">
        <label
          className="text-sm font-medium text-[#222222]"
          style={{ lineHeight: "20px" }}
        >
          Mark
        </label>
        <div className="flex flex-col gap-3">
          <input
            type="text"
            value={mark}
            onChange={(e) => setMark(e.target.value)}
            placeholder="Enter Mark"
            className="w-full h-10 px-2.5 py-2.5 text-sm font-normal text-[#222222] border border-[#EEEEEE] rounded-md bg-white placeholder:text-[#6D6D6D] placeholder:opacity-[0.87] focus:outline-none focus:ring-1 focus:ring-[#222222]"
            style={{ fontFamily: "Inter, sans-serif" }}
          />
          <button
            type="button"
            className="text-sm font-semibold text-[#222222] hover:underline text-left w-fit"
            style={{ lineHeight: "20px" }}
          >
            +Add New Mark for Search
          </button>
        </div>
      </div>
    </div>
  );
}

function ActionFooter({
  onBack,
  onClose,
  onSave,
}: {
  onBack: () => void;
  onClose: () => void;
  onSave: () => void;
}) {
  return (
    <footer
      className="h-[60px] flex-shrink-0 border-t border-[#EEEEEE] flex items-center justify-between px-4 py-3 gap-[9px]"
      style={{ fontFamily: "Inter, sans-serif" }}
    >
      <button
        onClick={onBack}
        className="h-9 px-4 py-2 text-xs font-semibold text-[#6D6D6D] bg-white border border-[#EEEEEE] rounded-md hover:bg-[#F7F7F7] min-w-[61px]"
        style={{ lineHeight: "20px" }}
      >
        Back
      </button>
      <div className="flex items-center gap-5">
        <button
          onClick={onClose}
          className="h-9 px-4 py-2 min-w-[66px] text-xs font-semibold text-[#6D6D6D] bg-white border border-[#EEEEEE] rounded-md hover:bg-[#F7F7F7]"
          style={{ lineHeight: "20px" }}
        >
          Close
        </button>
        <button
          onClick={onSave}
          className="h-9 px-4 py-2 min-w-[128px] text-xs font-semibold text-white rounded-md bg-[#222222] hover:bg-[#333333] transition-colors"
          style={{ lineHeight: "20px" }}
        >
          Save & Continue
        </button>
      </div>
    </footer>
  );
}

export default function NewApplicationPage() {
  const [activeTab, setActiveTab] = useState<
    "discussion" | "filing" | "status"
  >("discussion");
  const [activeMarkId, setActiveMarkId] = useState("8");
  const [activeFilingId, setActiveFilingId] = useState("f1");
  const [activeStatusId, setActiveStatusId] = useState("s1");
  const [activeNavIndex, setActiveNavIndex] = useState(2);

  const leftPanelItems =
    activeTab === "filing"
      ? FILING_ITEMS
      : activeTab === "status"
        ? STATUS_ITEMS
        : MARK_ITEMS;
  const activeLeftId =
    activeTab === "filing"
      ? activeFilingId
      : activeTab === "status"
        ? activeStatusId
        : activeMarkId;
  const onLeftSelect =
    activeTab === "filing"
      ? setActiveFilingId
      : activeTab === "status"
        ? setActiveStatusId
        : setActiveMarkId;

  return (
    <div
      className="flex h-screen bg-[#F7F7F7] overflow-hidden"
      style={{ fontFamily: "Inter, sans-serif" }}
    >
      <SideNavigation
        activeNavIndex={activeNavIndex}
        onNavSelect={setActiveNavIndex}
      />

      <div className="flex-1 flex flex-col min-w-0">
        <HeaderBar />

        <main className="flex-1 overflow-hidden p-2 min-h-0">
          <div className="bg-white rounded-lg h-full flex flex-col overflow-hidden border border-[#EEEEEE]">
            <TabBar activeTab={activeTab} onTabChange={setActiveTab} />

            <div className="flex flex-1 min-h-0 overflow-hidden">
              <LeftPanel
                items={leftPanelItems}
                activeMarkId={activeLeftId}
                onMarkSelect={onLeftSelect}
              />

              <div className="flex-1 flex flex-col min-w-0 overflow-hidden">
                <div className="flex-1 overflow-y-auto p-6">
                  {activeTab === "status" ? (
                    activeStatusId === "s1" ? (
                      <FormalitiesCheckView />
                    ) : (
                      <div
                        className="text-sm text-[#6D6D6D]"
                        style={{ fontFamily: "Inter, sans-serif" }}
                      >
                        {STATUS_ITEMS.find((s) => s.id === activeStatusId)?.label} — Coming soon
                      </div>
                    )
                  ) : activeTab === "filing" ? (
                    activeFilingId === "f1" ? (
                      <ChecklistDocumentsToClientView />
                    ) : activeFilingId === "f2" ? (
                      <DocumentsFromClientView />
                    ) :                     activeFilingId === "f3" ? (
                      <FilingDetailsToClientView />
                    ) :                     activeFilingId === "f4" ? (
                      <ConfirmationOfFilingDetailsView
                        onGoToEditFilingDetails={() => {
                          setActiveFilingId("f3");
                        }}
                      />
                    ) : activeFilingId === "f5" ? (
                      <StampPaperDetailsToVendorView />
                    ) : activeFilingId === "f6" ? (
                      <StampPaperFromVendorView />
                    ) : activeFilingId === "f7" ? (
                      <PreparationOfPowerOfAttorneyView />
                    ) : activeFilingId === "f8" ? (
                      <PreparationOfUserAffidavitView
                        onSkipToNextStep={() => {
                          const idx = FILING_ITEMS.findIndex((f) => f.id === activeFilingId);
                          if (idx >= 0 && idx < FILING_ITEMS.length - 1) {
                            setActiveFilingId(FILING_ITEMS[idx + 1].id);
                          }
                        }}
                      />
                    ) : activeFilingId === "f9" ? (
                      <SignatureFromClientView />
                    ) : activeFilingId === "f10" ? (
                      <NotarisationOfDocumentsView />
                    ) : activeFilingId === "f11" ? (
                      <ScanningOfDocumentsView />
                    ) : activeFilingId === "f12" ? (
                      <UploadingApplicationDetailsView />
                    ) : activeFilingId === "f13" ? (
                      <FilingOfApplicationView />
                    ) : activeFilingId === "f14" ? (
                      <AcknowledgementToClientView />
                    ) : activeFilingId === "f15" ? (
                      <FilingOfExpeditedApplicationView
                        leadId={null}
                        onSuccess={() => {
                          const idx = FILING_ITEMS.findIndex((f) => f.id === activeFilingId);
                          if (idx >= 0 && idx < FILING_ITEMS.length - 1) {
                            setActiveFilingId(FILING_ITEMS[idx + 1].id);
                          }
                        }}
                      />
                    ) : activeFilingId === "f16" ? (
                      <InvoiceToClientForExpeditedApplicationView
                        leadId={null}
                        onSuccess={() => {
                          const idx = FILING_ITEMS.findIndex((f) => f.id === activeFilingId);
                          if (idx >= 0 && idx < FILING_ITEMS.length - 1) {
                            setActiveFilingId(FILING_ITEMS[idx + 1].id);
                          }
                        }}
                      />
                    ) : activeFilingId === "f17" ? (
                      <PaymentFromClientExpeditedView
                        leadId={null}
                        onSuccess={() => setActiveFilingId("f1")}
                      />
                    ) : (
                      <div
                        className="text-sm text-[#6D6D6D]"
                        style={{ fontFamily: "Inter, sans-serif" }}
                      >
                        Content for {FILING_ITEMS.find((f) => f.id === activeFilingId)?.label} — Coming soon
                      </div>
                    )
                  ) : activeMarkId === "8" ? (
                    <LegalAdviceView />
                  ) : activeMarkId === "11" ? (
                    <InvoiceToClientFinalView leadId={null} />
                  ) : activeMarkId === "12" ? (
                    <PaymentFromClientView />
                  ) : (
                    <div
                      className="text-sm text-[#6D6D6D]"
                      style={{ fontFamily: "Inter, sans-serif" }}
                    >
                      Content for step {activeMarkId} — Coming soon
                    </div>
                  )}
                </div>

                <ActionFooter
                  onBack={() => {
                    const items = activeTab === "filing" ? FILING_ITEMS : MARK_ITEMS;
                    const activeId = activeTab === "filing" ? activeFilingId : activeMarkId;
                    const idx = items.findIndex((m) => m.id === activeId);
                    if (idx > 0) {
                      if (activeTab === "filing") setActiveFilingId(items[idx - 1].id);
                      else setActiveMarkId(items[idx - 1].id);
                    }
                  }}
                  onClose={() => {}}
                  onSave={() => {}}
                />
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}
